import { isBrowser } from '../utils/isBrowser';
const sdkInitType = 'react';
if (isBrowser) {
    window.__SOLIDGATE_PRIVATE__SDK_INIT_TYPE = sdkInitType;
}
//# sourceMappingURL=index.js.map